import React from "react";
import { Link } from "react-router-dom";
import { Calendar, MapPin, Coins, Users } from "lucide-react";

export default function EventCard({ event, index = 0 }) {
  const dateStr = new Date(event.date + "T00:00:00").toLocaleDateString("en-AU", {
    weekday: "short", day: "numeric", month: "short",
  });
  const seatsLeft = Math.max(0, (event.seats_total || 0) - (event.seats_sold || 0));
  return (
    <Link
      to={`/events/${event.id}`}
      data-testid={`event-card-${event.id}`}
      className="group block bg-navy-paper border border-slate-800 hover:border-gold/50 hover:-translate-y-1 transition-all duration-300 animate-fade-up overflow-hidden"
      style={{ animationDelay: `${index * 90}ms` }}
    >
      <div className="relative h-48 overflow-hidden">
        <img src={event.image} alt={event.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
        <div className="absolute inset-0 bg-gradient-to-t from-navy-paper via-navy-paper/30 to-transparent" />
        {event.featured && (
          <span className="absolute top-3 left-3 bg-gold text-navy text-[10px] font-bold uppercase tracking-widest px-3 py-1">Featured</span>
        )}
        <div className="absolute bottom-3 left-3 flex items-center gap-2 text-gold text-sm font-medium">
          <Calendar className="w-4 h-4" /> {dateStr} · {event.time}
        </div>
      </div>
      <div className="p-5">
        <h3 className="font-display text-xl font-bold text-white group-hover:text-gold transition-colors line-clamp-1">{event.title}</h3>
        {event.subtitle && <p className="text-gold text-sm font-medium line-clamp-1 -mt-1" data-testid={`event-card-subtitle-${event.id}`}>{event.subtitle}</p>}
        <p className="text-slate-400 text-sm mt-1 flex items-center gap-1.5"><MapPin className="w-3.5 h-3.5" /> {event.venue_name}</p>
        <p className="text-slate-500 text-xs mt-1">{event.game_type}</p>
        <div className="mt-4 pt-4 border-t border-white/5 flex items-center justify-between">
          <span className="flex items-center gap-1.5 text-white font-semibold"><Coins className="w-4 h-4 text-gold" /> ${event.buy_in || 0} buy-in</span>
          <span className="flex items-center gap-1.5 text-slate-400 text-xs"><Users className="w-3.5 h-3.5" /> {seatsLeft} seats left</span>
        </div>
      </div>
    </Link>
  );
}
